import { Phone } from '../../../interfaces/Advisors';
import { PhoneDto } from '../../../interfaces/dtos/AdvisorsDto';

export default function transformPhones(dto: PhoneDto): Phone {
  return {
    tollFree: dto?.tollFree ?? '',
    local: dto?.local ?? '',
  };
}
